'use client';
import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';
import { SEVERITY_DISTRIBUTION } from './analyticsData';

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload?.length) return null;
  const total = SEVERITY_DISTRIBUTION.reduce((s, d) => s + d.value, 0);
  return (
    <div className="bg-white rounded-xl border shadow-elevated p-3 text-xs" style={{ borderColor: 'hsl(var(--border))' }}>
      <p className="font-semibold mb-1" style={{ color: payload[0].payload.fill }}>{payload[0].name}</p>
      <p className="text-muted">Count: <span className="font-bold text-foreground tabular-nums">{payload[0].value}</span></p>
      <p className="text-muted">Share: <span className="font-bold text-foreground tabular-nums">{Math.round((payload[0].value / total) * 100)}%</span></p>
    </div>
  );
};

export default function SeverityDistributionChart() {
  const total = SEVERITY_DISTRIBUTION.reduce((s, d) => s + d.value, 0);
  return (
    <div>
      <ResponsiveContainer width="100%" height={180}>
        <PieChart>
          <Pie
            data={SEVERITY_DISTRIBUTION}
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={78}
            paddingAngle={2}
            dataKey="value"
          >
            {SEVERITY_DISTRIBUTION.map((entry, i) => (
              <Cell key={`sev-cell-${i}`} fill={entry.fill} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
      <div className="space-y-1.5 mt-2">
        {SEVERITY_DISTRIBUTION.map((entry) => (
          <div key={`sev-leg-${entry.name}`} className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-sm flex-shrink-0" style={{ background: entry.fill }} />
            <span className="text-xs flex-1">{entry.name}</span>
            <span className="font-mono text-xs font-semibold tabular-nums">{entry.value}</span>
            <span className="text-xs text-muted w-10 text-right tabular-nums">{Math.round((entry.value / total) * 100)}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}